import axios from '@/clientAPI.ts'
import axiosV3 from '@/clientAPIV3.ts'
import {
    FeedPayloadV3,
    FeedTalentsCard,
    HostFeedResponseGeneralV3,
    HostFiltersType,
    HostStoriesType,
    HostStoryType
} from '@/features/feed/types.ts'

export const FEED_API = {
    seenTalents: async (body: {rookiesIDs: number[]}): Promise<FeedTalentsCard> => {
        const url = '/rookies/talents'
        const {data} = await axios.post(url, {exclude_rookies_ids: body.rookiesIDs})
        return data
    },
    storeActiveFilters: async ({filters}: {filters: HostFiltersType}) => {
        const jsonString = JSON.stringify(filters)
        const params = {filters: jsonString}
        const url = `/filters/carousel`
        const {data} = await axios.post(url, params)
        return data
    },
    clearActiveFilters: async () => {
        const url = '/filters/carousel'
        return await axios.delete(url)
    },

    getHostsStories: async (): Promise<HostStoriesType[]> => {
        const url = '/creators/feed/get-creators'
        const {data} = await axiosV3.get(url)
        return data
    },
    getHostStory: async ({creatorId}: {creatorId: number}): Promise<HostStoryType[]> => {
        const url = `/creators/${creatorId}/feed`
        const {data} = await axiosV3.post(url)
        return data
    },
    seenHostsStories: async ({creatorFeedIds}: {creatorFeedIds: number[]}) => {
        const url = `/creators/feeds/seen`
        const {data} = await axiosV3.post(url, {creatorFeedIds})
        return data
    }
}

export const hostFeedMuralV3 = async (params: FeedPayloadV3): Promise<HostFeedResponseGeneralV3> => {
    const {data} = await axiosV3.get<HostFeedResponseGeneralV3>('/creators/mural', {
        params: {...params}
    })
    return data
}

export const seenRookieV3 = async (params: {rookiesIDs: string[] | number[]}) => {
    const {data} = await axiosV3.post('/creators/seen', {
        creatorsIds: params.rookiesIDs
    })
    return data
}

type Verify18AgeWithGoCamBody = {
    showDetectedAgeNumber?: boolean
    advancedLiveness?: true
    language?: string
    linkBack?: string
}

export const verify18AgeWithGoCam = async (body: Verify18AgeWithGoCamBody): Promise<{url: string}> => {
    const {data} = await axiosV3.post('/age-verification/gocam', body)
    return data
}

export const getPhotoById = async (photoId: string) => {
    const {data} = await axiosV3.get(`/photos/${photoId}`)
    return data
}

export const getVideoById = async (videoId: string) => {
    const {data} = await axiosV3.get(`/videos/${videoId}`)
    return data
}

export const getMediaPackageContentById = async (mediaPackageId: string, creatorId: string) => {
    const {data} = await axiosV3.get(`/creators/${creatorId}/media-packages/${mediaPackageId}`)
    return data
}
